module.exports = __webpack_public_path__ + "static/media/shape0_4.c9815da1.obj";